export default "__VITE_ASSET__DTFW7mQ1__"